import { createAppErrorBoundary } from 'app-core'
import packageJson from '../package.json'

export default createAppErrorBoundary({ appVersion: packageJson.version })
